import {callURL} from './call';
import messageShow from "./messageShow";
import {push} from "connected-react-router";
import {ADV_TEMPLATES_ROUTE} from "../components/Root/routes";
import {UPDATE_DATA} from "../types";
import {signerURL} from "../url";
import logout from "./logout";

const getTemplates= (formValues) => async (dispatch) =>
{
    delete formValues.templates;
    const onResult= (result) =>
    {
        if(result && result[1].success)
        {
            const templates=result[1].result.templates;
            if(templates && templates.length>0)
            {
                dispatch({type:UPDATE_DATA,payload:{templates:templates,order:formValues.order,mail:formValues.mail}});
                dispatch(push(ADV_TEMPLATES_ROUTE));
            }
            else
                dispatch(messageShow({message: 'Error, no existen plantillas PDF', type: 'error'}));
        }
        else
        {
            if(result && result[1] && result[1].code===440)
                dispatch(logout());
            else
                dispatch(messageShow({message: result[1].detail, type: 'error'}));
        }

    }
    dispatch(callURL(signerURL,"rest/UserService/getPDFTemplatesInformation",formValues,onResult));
};
export default getTemplates;